import { useState } from "react";
import { useQuery } from "@apollo/client";
import client from "../../../client";

const QueryDataNew = ({
  query,
  variables = {},
  children,
  mockApi,
  setStateF,
}) => {
  // store data to avoide re-overwriting the data
  const [_data, setData] = useState(null);
  const [status, setStatus] = useState(null);

  const { loading, error, data } = useQuery(
    query,
    mockApi
      ? {
          client,
          variables,
          fetchPolicy: "network-only",
          onCompleted: () => {
            setStatus("loaded");
            setData(data);
          },
        }
      : {
          variables,
          fetchPolicy: "network-only",
          onCompleted: () => {
            setStatus("loaded");
            setData(data);
          },
        }
  );

  if (loading) {
    return children({ data: _data, setData, loadingStatus: "loading" });
  }

  if (error) {
    return children({ loadingStatus: "error" });
  }

  if (setStateF) setStateF(_data, false);
  return children({ data: _data, loadingStatus: status, setData });
};

export default QueryDataNew;
